import { useParams } from 'react-router-dom';
import CaseDetail from '@/pages/CaseDetail';
import { useSyncIdQuery } from './useSyncIdQuery';

export default function MobileCaseDetail() {
  const { id } = useParams();
  useSyncIdQuery(id);
  return <CaseDetail />;
}

